import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";

export function useCaregiverUploadedDocuments(caregiverId: CaregiverProfileCaregiver["id"]) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["caregiverProfileModal", caregiverId, "uploadedDocuments"],
    queryFn: () =>
      api.get("/agencies/:agencyId/caregivers/:caregiverId/uploaded_documents", {
        path: { caregiverId },
      }),
  });
}
